import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Ajax from '../ajax/Ajax';

class Bestiary extends Component {
	
	constructor(props) {
		super(props);
		this.state = {overlay: false, bestiary: false, keys: false, showEditor: false, bestiaryTitleInput: "", bestiaryAuthorInput: "", bestiaryContentInput: "", bestiaryImagesInput: []};
        this.openEditor = this.openEditor.bind(this);
        this.closeEditor = this.closeEditor.bind(this);
        this.saveBestiary = this.saveBestiary.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.addImage = this.addImage.bind(this);
        this.closeOverlay = this.closeOverlay.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getBestiary().then(function(bestiary) {			
			obj.setState({bestiary: bestiary, keys: Object.keys(bestiary).reverse()});			
		});
    }
    
    showImage(img) {
		var obj = this;
		return function(event) {
			obj.setState({overlay: img});
		};
	}
	
	closeOverlay(event) {
		this.setState({overlay: false});
	}
	
	deleteImage(remove) {
		var obj = this;
		return function(event) {
            event.stopPropagation();
            var imgs = obj.state.bestiaryImagesInput;
			if (! (typeof imgs === "undefined")) {
				var newImgs = [];
				for (var idx in imgs) {
					var img = imgs[idx];
					if (img !== remove)
						newImgs.push(img);
				}
				obj.setState({bestiaryImagesInput: newImgs, overlay: false});
			}
		};
	}
	
	addImage(event) {
		var img = event.target.files[0];
		console.log(img);
		var obj = this;
		if (img.name.length > 0) {
            Ajax.uploadFile(img).then(function (result) {
				if (result === "FAIL") {
                    return;
                }
                var imgs = obj.state.bestiaryImagesInput;				
				imgs.push(result);
				obj.setState({bestiaryImagesInput: imgs});
			});
        }			
	}
	
	openEditor() {
		this.setState({showEditor: true});
    }

    closeEditor() {
        this.setState({showEditor: false});
    }    

    saveBestiary() {
        var obj = this;
        var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
        var beast = {title: this.state.bestiaryTitleInput, author: this.state.bestiaryAuthorInput, content: this.state.bestiaryContentInput, imgs: this.state.bestiaryImagesInput}
        Ajax.getBestiary().then((bestiary) => {            
            bestiary[id] = beast;
            
            Ajax.postBestiary(bestiary).then((output) => {
                obj.setState({bestiary: bestiary, keys: Object.keys(bestiary)}, obj.closeEditor);
            });            
        });
    }
	
	render() {
        var bestiary = this.state.bestiary;
        var keys = this.state.keys;
        var showEditor = this.state.showEditor;
        var overlay = this.state.overlay;
		var obj = this;
		
		return (
		<div className="Bestiary">			
			{ overlay ? (<div className="ImageOverlay" id="overlay" onClick={this.closeOverlay}><img src={overlay} /></div>) : null }
			<div className="BestiaryList">				
				<div className="AddBestiarySymbol" onClick={this.openEditor}>Ajouter...</div>
				
				{bestiary && keys ? 				
				keys.map(function(key, idx) {					
					var beast = bestiary[key];
					return (
					<div id={key} key={idx} className="Report">
                        <div className="BestiaryTitle">{beast.title}</div>
                        <div className="BestiaryAuthor">{beast.author}</div>
						<div className="BestiaryContent" dangerouslySetInnerHTML={{__html: beast.content.replace(/\n/g, "<br/>")}}></div>
                        <div className="BestiaryImages">                           
                            {
                                typeof beast.imgs !== "undefined" ? beast.imgs.map(function(img, idx) {
                                    return (<div className="BestiaryImage" key={idx} onClick={obj.showImage(img)} style={{backgroundImage: 'url(' + img + ')'}}></div>);
                                }) : null
                            }
                        </div>
					</div>
					)
				}): null
				}
				
			</div>
            { showEditor ? (
                <div className="Overlay">
                    <div className="OverlayCloseButton" onClick={this.closeEditor}>x</div>
                    <div className="BestiaryEditor">
                        <div className="BestiaryEditorLabel">Titre</div>
                        <div className="BestiaryTitleInput"><input type="text" value={this.state.bestiaryTitleInput} onChange={(event) => { this.setState({bestiaryTitleInput: event.target.value}); } }></input></div>
                        <div className="BestiaryEditorLabel">Auteur</div>
                        <div className="BestiaryAuthorInput"><input type="text" value={this.state.bestiaryAuthorInput} onChange={(event) => { this.setState({bestiaryAuthorInput: event.target.value}); } }></input></div>
                        <div className="BestiaryEditorLabel">Description</div>
                        <div className="BestiaryContentInput"><textarea value={this.state.bestiaryContentInput} resize="false" onChange={(event) => { this.setState({bestiaryContentInput: event.target.value}); } }></textarea></div>
                        <div className="BestiaryImages">
                            <div className="BestiaryEditorLabel">Images</div>
                            {
                                typeof this.state.bestiaryImagesInput === "undefined" ? null : this.state.bestiaryImagesInput.map(function(img, idx) {
                                    return (
                                    <div className="BestiaryImage" key={idx} onClick={obj.showImage(img)} style={{backgroundImage: 'url(' + img + ')'}}>
                                        <div className="BestiaryImageDelete" onClick={obj.deleteImage(img)}><FontAwesomeIcon icon="trash"/></div>
                                    </div>
                                    );
                                })
                            }
                            <label htmlFor="imageUpload">
                                <div className="BestiaryImage BestiaryImageAdd" key="addImage">
                                    <FontAwesomeIcon icon="plus-circle"/>
                                </div>	
                            </label>
                            <input type="file" id="imageUpload" onChange={obj.addImage} accept="image/*"/>
                        </div>
                        <div className="BestiaryContentButton" onClick={this.saveBestiary}>Sauvegarder</div>
                    </div>
                </div>) : null 
            } 
		</div>
            );
	}
}

export default Bestiary;



// WEBPACK FOOTER //
// ./src/components/Bestiary.js